import { PatientApis } from '../../profile/apis/PatientApis';

export const PatientServices = {
  UpdateUserName: async (username) => {
    const name = username.name;
    let [firstName, middlename, lastName] = name.trim().split(' ');
    let payload = {};

    firstName = (lastName && middlename )? firstName+' '+ middlename : firstName;
    lastName = lastName? lastName : middlename;

    payload.first_name = firstName;
    payload.last_name = lastName;

    try {
      const response = await PatientApis.updateProfile(payload);
      return response;
    } catch (error) {
      console.error('failed to update the username', error);
      throw error;
    }
  },
  updatePhoto: async (data) => {
    try {
      const response = await PatientApis.updatePhoto(data);
      return response;
    } catch (error) {
      console.error('failed to push teh file', error);
      throw error;
    }
  },
  fetchArchiveConversations: async () => {
    try {
      const response = await PatientApis.archiveConversation();
      return response.data;
    } catch (error) {
      console.error('failed to fetch archieve conversation', error);
      throw error;
    }
  },
  restoreArchive: async (conv_id) => {
    try {
      const response = await PatientApis.ArchieveRestore(conv_id);
      return response;
    } catch (error) {
      console.error('failed to restore the conversation', error);
      throw error;
    }
  },
  deleteArchive: async (conv_id) => {
    try {
      const response = await PatientApis.ArchieveDelete(conv_id);
      return response;
    } catch (error) {
      console.error('failed to delete the conversation', error);
      throw error;
    }
  },
  deleteMany: async (payload) => {
    try {
      const response = await PatientApis.deleteManyArchive(payload);
      console.log('response deleting archieveing conversations', response);
      return response;
    } catch (error) {
      console.error('failed to delete all the archieved conversations', error);
      throw error;
    }
  },
  restoreMany: async (payload) => {
    try {
      const response = await PatientApis.restoreManyArchive(payload);
      return response;
    } catch (error) {
      console.error('failed to restore all the conversations', error);
      throw error;
    }
  },
  submitFeedback: async (rating, feedback_text) => {
    try {
      const response = await PatientApis.submitFeedback(rating, feedback_text);
      console.log('the response for the rating', response);
      return response;
    } catch (error) {
      console.error('failed to sub,it the response', error);
      throw error;
    }
  },
};
